import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var Developer =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Developer, _BaseData);

  function Developer() {
    _classCallCheck(this, Developer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Developer).call(this, "Developer"));
  }

  _createClass(Developer, [{
    key: "GetByPropertyId",
    value: function () {
      var _GetByPropertyId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(propertyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByPropertyId/").concat(propertyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByPropertyId(_x) {
        return _GetByPropertyId.apply(this, arguments);
      }

      return GetByPropertyId;
    }()
  }, {
    key: "GetProperties",
    value: function () {
      var _GetProperties = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(developerId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetProperties/").concat(developerId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetProperties(_x2) {
        return _GetProperties.apply(this, arguments);
      }

      return GetProperties;
    }()
  }, {
    key: "Search",
    value: function () {
      var _Search = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(term) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/Search/").concat(term), {
                  doNotShowLoading: true
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function Search(_x3) {
        return _Search.apply(this, arguments);
      }

      return Search;
    }()
  }, {
    key: "UpdatePropertyDeveloper",
    value: function () {
      var _UpdatePropertyDeveloper = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(propertyId, developerId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.put("/api/".concat(this._controller, "/UpdatePropertyDeveloper/").concat(propertyId, "/").concat(developerId == null ? "" : developerId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function UpdatePropertyDeveloper(_x4, _x5) {
        return _UpdatePropertyDeveloper.apply(this, arguments);
      }

      return UpdatePropertyDeveloper;
    }()
  }, {
    key: "RemoveDeveloper",
    value: function () {
      var _RemoveDeveloper = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(propertyId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.put("/api/".concat(this._controller, "/RemoveDeveloper/").concat(propertyId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function RemoveDeveloper(_x6) {
        return _RemoveDeveloper.apply(this, arguments);
      }

      return RemoveDeveloper;
    }()
  }]);

  return Developer;
}(BaseData);

export default new Developer();